module.exports = __webpack_public_path__ + "static/media/sp_recipe.8b104c96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/books/sp_recipe.svg
// module id = 406
// module chunks = 0